import SadBoy from "../../assets/Icons/SadBoy";
import { Button } from "../Buttons";

const DeleteAccountForm2 = ({ confirmHandler, cancelHandler }) => {
  return (<div className="flex flex-col items-center justify-center gap-[19px]">
    <div
      className="bg-[#E53F5015] p-[10px] text-center
      h-[37.6] w-[46.6]
      md:h-[115] md:w-[110.5]
      rounded-[50%] text-[#00C08B]"
    >
      <SadBoy />
    </div>
    <p className="font-Apparat font-[700] text-[16px] md:text-[20px] leading-[20px] md:leading-[24px] tracking-[-2%] text-[#424952] max-w-[50%] text-center">
      Are you sure you want to delete your account?
    </p>
    <p className="font-Apparat font-[500] text-[12px] md:text-[16px] leading-[17px] md:leading-[19px] tracking-[-2%] text-[#424952] text-opacity-[70%]  text-center max-w-[85%]">
      We’re sad to see you go! Deleting your account means losing all your info with us. Is there anything we can do to help you stay?
    </p>
    <div className="flex flex-col md:flex-row gap-[16px] w-full">
      <div className="w-[100%] md:w-[50%]">
        <Button variant="quaternary"
          onClick={confirmHandler}
          className="!text-[#424952] bg-[#EDEDED]  w-full flex justify-center" title={"Yes delete my account"} />
      </div>
      <div className="w-[100%] md:w-[50%]">
        <Button
          className=" w-full flex justify-center"
          title={"Keep My account"}
          onClick={cancelHandler}
        />
      </div>

    </div>
  </div>)
}
export default DeleteAccountForm2;